import { useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { uploadQApdf } from "../../redux/services/questionSlice";

const QuestionUpload = ({ subjectId, getSubjectWiseQuestion }) => {
  const [toggle, setToggle] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [files, setFiles] = useState({ englishFile: "", hindiFile: "" });
  const fileInputRef = useRef(null);
  const dispatch = useDispatch();

  const handleClose = () => setToggle(false);

  const handleQAUpload = async () => {
    if (!files) return;

    const formData = new FormData();
    formData.append("english_file", files?.englishFile);
    formData.append("hindi_file", files?.hindiFile);
    formData.append("subjectId", subjectId);

    try {
      setUploading(true); // 🔥 start loading

      const response = await dispatch(uploadQApdf(formData));

      if (response?.payload?.status) {
        toast(response?.payload?.message, {
          autoClose: 2000,
          pauseOnHover: false,
        });
        handleClose();
        getSubjectWiseQuestion();
      }
    } finally {
      setUploading(false); // 🔥 stop loading
    }
  };

  const handleFileUpload = (e, type) => {
    const file = e.target.files[0];
    if (!file) return;
    setFiles((prevFiles) => ({ ...prevFiles, [type]: file }));
  };

  const handleButtonClick = () => {
    if (toggle) setToggle(false);
    else setToggle(true);
  };
  return (
    <>
      <button onClick={handleButtonClick} disabled={uploading} className={`px-4 py-2 font-semibold rounded-lg uppercase border-2 border-[#124699] bg-[#124699] text-white`}>
        Question Upload
      </button>
      {toggle && (
        <section className="fixed z-50 inset-0 overflow-hidden duration-300 ease-in-out">
          <div className="flex items-center justify-center min-h-screen text-center sm:block">
            <div className="fixed inset-0 transition-opacity" aria-hidden="true">
              <div className="absolute inset-0 bg-gray-500 opacity-75" onClick={handleClose}></div>
            </div>
            <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
              &#8203;
            </span>

            <div className="inline-block mx-[10px] w-full bg-white rounded-lg space-y-4  text-left overflow-hidden shadow-xl transform transition-all sm:align-middle max-w-lg md:max-w-2xl">
              <div className="relative w-full flex flex-col items-center rounded-xl py-2 overflow-hidden text-slate-700 bg-white bg-clip-border">
                <span className="text-gray-900 font-medium capitalize text-xl py-4">Upload Question File</span>
                <div className="flex items-center justify-center md:flex-row flex-col  gap-4 border-t border-gray-400 w-full py-4 px-4">
                  <div className="flex flex-col w-[16rem] items-center">
                    <label className="mb-2">English file</label>
                    <input type="file" ref={fileInputRef} accept=".docx" onChange={(e) => handleFileUpload(e, "englishFile")} className="block border w-full shadow-sm rounded-lg text-md focus:z-10 py-1 px-2" />
                  </div>
                  <div className="flex flex-col w-[16rem] items-center">
                    <label className="mb-2">Hindi file</label>
                    <input type="file" ref={fileInputRef} accept=".docx" onChange={(e) => handleFileUpload(e, "hindiFile")} className="block border w-full shadow-sm rounded-lg text-md focus:z-10 py-1 px-2" />
                  </div>
                </div>
                <div className="flex items-center justify-center md:flex-row flex-col gap-4 w-full py-4">
                  <button onClick={handleClose} type="button" className="max-w-[200px] w-full h-[45px] text-md font-medium text-[#124699] border border-[#124699] rounded-lg">
                    Cancel
                  </button>
                  <button onClick={handleQAUpload} type="button" disabled={uploading} className={`max-w-[200px] w-full h-[45px] text-md font-medium border border-[#124699] rounded-lg ${uploading ? "bg-[#e8effa] text-[#124699] cursor-not-allowed" : "bg-[#124699] text-white"}`}>
                    {uploading ? "Uploading..." : "Upload"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  );
};

export default QuestionUpload;
